<template>
  <div class="card-item shadowless">
    <div class="card-item-header">
      <div class="transaction-header-resume">
        <div class="transaction-header-amount">
          <span
            :id="`${boleto._id}-amount`"
            class="content-title">
            Valor:
          </span>
          <span
            :id="`${boleto._id}-amount`">
            $ {{ formatNumber(boleto.amount) }}
          </span>
        </div>
        <div class="transaction-header-payments">
          <span class="content-title">Parcela</span>
          <div>
            <b-tooltip
              :key="boleto.paymentNumber"
              position="is-right"
              type="is-light">
              <span class="content-value transaction-header-payment">{{ `${boleto.paymentNumber}` }}</span>
            </b-tooltip>
          </div>
        </div>
        <div class="transaction-header-payed">
          <span class="content-title">Data de vencimento: </span>
          <span>{{ dateToFormatedString(boleto.dueDateBoleto, 'DD/MM/YYYY') }}</span> <!--Calcular el ultimo día del mes-->
        </div>
        <div class="transaction-header-status">
          <b-tooltip label="Status do pagamento" position="is-bottom" type="is-light">
            <div class="tag med-size-text" :class="`${boleto.status ? boleto.status.toLowerCase() : ''}`">
              {{ boleto.statusTranslate }}
            </div>
          </b-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dateToFormatedString } from '@/infrastructure/date';
import { formatNumber } from '@/infrastructure/format';

export default {
  props: {
    currentUserIsClient: { type: Boolean, default: false },
    isExtended: { type: Boolean, default: false },
    boleto: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      monetarySignShowing: 'R$'
    };
  },
  computed: {
  },
  methods: {
    formatNumber: number => formatNumber({ number }),
    dateToFormatedString: (date, format) => dateToFormatedString(date, format)
  }
};
</script>
<style scoped>
.card-item {
  overflow: visible;
}
/* header */
.card-item-header {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 2rem;
}
.card-item-header .transaction-header-resume {
  width: 100%;
  display: grid;
  grid:
    "amount payments payed status" auto
    /1fr 1fr 1fr 6rem;
  gap: 0.5rem 1rem;
  place-items: center;
}
.transaction-header-amount { grid-area: amount; }
.transaction-header-payments { grid-area: payments; }
.transaction-header-payed { grid-area: payed; }
.transaction-header-status { grid-area: status; z-index: 1; }
.card-item-header .transaction-header-resume .transaction-header-amount,
.card-item-header .transaction-header-resume .transaction-header-payments,
.card-item-header .transaction-header-resume .transaction-header-payed {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  gap: 0.3rem 0.5rem;
}
.transaction-header-payment {
  background-color: var(--color-g-inactive);
  border-radius: 1.5rem;
  padding: 0rem 0.5rem;
  margin-left: 0.3rem;
}
/* details */
.card-item-details {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.3rem;

  background-color: #F9F9F9;
  border-radius: 1.5rem;
  padding: 0rem 1.5rem;
  width: 100%;
  max-height: 0rem;
  overflow: hidden;
}
.card-item-details.show {
  max-height: 100rem;
  margin-top: 3%;
  padding: 3% 5%;
  overflow-y: auto;
  overflow: visible;
}
.details-header {
  display: flex;
  flex-flow: row wrap;
  gap: 0.3rem 1rem;
  align-content: center;
  justify-content: flex start;
}
.details-header > span{
  display: flex;
  flex-flow: row wrap;
  gap: 0rem 0.5rem;
  align-content: center;
  justify-content: flex start;
}
/* payment details */
.card-item-details .selected-operation .selected-payment {
  width:100%;
  display: flex;
  flex-flow: column wrap;
  gap: 0.2rem 1rem;
}
.selected-payment.show {
  background-color: rgb(243, 243, 243);
  border-radius: 1rem;
}
.selected-payment-details .gloss {
  display: grid;
  grid:
    "payment title monetary-sign button"
    / 5rem 1fr 0.5fr 1.2rem;
  gap: 0.5rem;
  padding: 0.2rem;
}
.detail-glosses.hide{
  max-height: 0rem;
  overflow: hidden;
}
.detail-glosses.show {
  max-height: 100rem;
  overflow-y: auto;
  overflow: visible;
  background-color: rgb(243, 243, 243);
}
.selected-payment-details .gloss .gloss-payment {
  grid-area: payment;
  place-self: center;
}
.selected-payment-details .gloss .gloss-title {
  grid-area: title;
  place-self: center start;
}
.selected-payment-details .gloss .gloss-monetary-sign {
  grid-area: monetary-sign;
  place-self: center start;
}
.selected-payment-details .gloss .gloss-button {
  grid-area: button;
  place-self: center start;
}
/* otros */
.content-title {
  color: var(--primary);
  font-weight: 600;
}
.tag {
  color: white;
}
.tag.paid, .tag.consignable {
  background-color: var(--primary);
}
.tag.requested {
  background-color: var(--yellow);
}
.tag.expired {
  background-color: var(--secondary-dark);
}
.low-line {
  border-bottom: 1px solid var(--color-silver);
}
.up-line {
  border-bottom: 1px solid var(--color-silver);
  border-top: 1px solid var(--color-silver);
}
@media (max-width: 1000px) {
  .card-item-header .transaction-header-resume {
    grid:
      "amount payments status" auto
      "amount payed status" auto
      / 6rem 1fr 6rem;
  }
}
@media (max-width: 580px) {
  .card-item.shadowless {
    border-radius: 20px;
    padding: 6%
  }
  .card-item-header {
    font-size: 0.9rem;
    gap: 1rem;
  }
  .card-item-header .transaction-header-resume {
    grid:
      "amount status" auto
      "payments payments" auto
      "payed payed" auto
      / 1fr 3rem;
  }
  .transaction-header-status { justify-self: right; }
  .card-item-header .transaction-header-resume .transaction-header-amount,
  .card-item-header .transaction-header-resume .transaction-header-payments,
  .card-item-header .transaction-header-resume .transaction-header-payed {
    justify-content: left;
  }
  .card-item-details.show {
    margin: 1rem 1%;
  }
  .selected-payment-details {
    font-size: 0.7rem;
  }
}
@media (max-width: 400px) {
  .selected-payment-details {
    font-size: 0.75rem;
  }
  .card-item-details {
    font-size: 0.9rem;
  }
  .selected-payment-details .gloss {
  display: grid;
  grid:
    "payment title monetary-sign button"
    / 1rem 1fr 4rem 1rem;
}
}
</style>
